// Instagram content plan for @lempole.wine
// 15 posts × 4 content pillars, plus Highlights and Bio.
// Assets reuse existing site images so nothing needs re-shooting.

const IG = {
  hero:         'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/3aysd8m4_Hero%20image%20-%20desktop.png',
  bottle:       'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/r7148kd2_Generated%20with%20Kive.ai%20-%20kive-image%20%2815%29.webp',
  terraces:     'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/bmap93ez_IMG_6323.webp',
  breathe:      'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/6vxqu2fr_Generated%20with%20Kive.ai%20-%20kive-image%20%2814%29.webp',
  fruit:        'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/x59mmx03_Generated%20with%20Kive.ai%20-%20Bottle%20shaped%20indentation%20aggiungi%20l%27etichetta%20di%20Lempole.webp',
  slothLogo:    'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/em9l4iqr_lempole-sloth.png',
  vigneron:     process.env.PUBLIC_URL + '/images/vigneron-retouched.webp',
  grapes:       process.env.PUBLIC_URL + '/venues/grapes-vine.jpg',
  basket:       process.env.PUBLIC_URL + '/venues/basket.jpg',
  bottlesIris:  process.env.PUBLIC_URL + '/venues/bottles-iris.jpg',
  kidsHarvest:  process.env.PUBLIC_URL + '/venues/kids-harvest.jpg',
};

export const IG_PROFILE = {
  handle: 'lempole.wine',
  displayName: 'Lempole',
  avatar: IG.slothLogo,
  stats: { posts: 15, followers: 428, following: 89 },
  bioLines: [
    'Slow Wine philosophy 🌿',
    'Terrazzamenti storici di Lamole · 600 m',
    'Sangiovese Rosato IGT Toscana',
    '1.000 bottiglie a vendemmia',
  ],
  link: { label: 'lempole.com', url: 'https://lempole.com' },
  category: 'Cantina · Chianti Classico',
};

// Story Highlights (permanent circular covers)
export const IG_HIGHLIGHTS = [
  { label: 'Manifesto', sketch: 'perche-un-bradipo' },
  { label: 'Vigna',     sketch: 'un-anno-in-vigna-mese-per-mese' },
  { label: 'Cantina',   sketch: 'solo-acciaio-perche-no-legno' },
  { label: 'Diario',    sketch: 'ritorno-vigneron-lamole' },
  { label: 'Visite',    sketch: 'madonnino-dei-campacci' },
  { label: 'Vendemmia', sketch: 'vendemmia-manuale-40-quintali' },
];

// 15 posts — a natural cadence for a launch month.
// pillar: 'manifesto' | 'terroir' | 'vigneron' | 'prodotto'
// media:  { kind: 'photo' | 'sketch' | 'quote', src?, slug?, text? }
export const IG_POSTS = [
  {
    id: 1,
    pillar: 'manifesto',
    media: { kind: 'photo', src: IG.hero },
    caption: [
      'Un vino nasce nel silenzio.',
      '',
      'Da 600 metri di quota, sui terrazzamenti storici di Lamole, comincia il cammino di Lempole. Un progetto piccolo, indipendente, dedicato al Sangiovese di montagna e alla lentezza necessaria per fare le cose bene.',
      '',
      'Benvenuti nel diario.',
    ],
    hashtags: ['#lempole', '#slowwine', '#lamole', '#chianticlassico', '#sangiovese', '#viticolturaeroica'],
  },
  {
    id: 2,
    pillar: 'manifesto',
    media: { kind: 'sketch', slug: 'perche-un-bradipo' },
    caption: [
      'Perché un bradipo?',
      '',
      'Perché la lentezza non è debolezza. È una strategia. Il bradipo sceglie ogni gesto — e ogni gesto conta. È il nostro simbolo, non un vezzo grafico.',
      '',
      '👉 Storia completa nel diario: lempole.com/diario/perche-un-bradipo',
    ],
    hashtags: ['#slothspirit', '#slowwine', '#winemanifesto', '#lempole'],
  },
  {
    id: 3,
    pillar: 'terroir',
    media: { kind: 'photo', src: IG.terraces },
    caption: [
      '600 metri di quota.',
      'Sessant\u2019anni di silenzio.',
      '',
      'I terrazzamenti del Madonnino dei Campacci, prima di noi, erano stati abbandonati oltre mezzo secolo. Muretti a secco crollati, bosco rientrato, fasce dimenticate. Recuperarli, una pietra alla volta, è quello che stiamo facendo.',
    ],
    hashtags: ['#lamole', '#terrazzamenti', '#viticolturaeroica', '#unescoheritage', '#drystonewalls'],
  },
  {
    id: 4,
    pillar: 'terroir',
    media: { kind: 'sketch', slug: 'un-anno-in-vigna-mese-per-mese' },
    caption: [
      'Un anno in vigna, mese per mese.',
      '',
      'Gennaio potatura, aprile germoglio, giugno fioritura, settembre vendemmia, dicembre riposo. La musica non cambia — ma ogni annata la suona diversa.',
    ],
    hashtags: ['#vignaiolo', '#calendarioagricolo', '#stagioninvigna', '#chiantidigital'],
  },
  {
    id: 5,
    pillar: 'terroir',
    media: { kind: 'photo', src: IG.grapes },
    caption: [
      'Sangiovese. Uno alla volta.',
      '',
      'Grappoli piccoli, buccia spessa, colore intenso. È il carattere che ci dà Lamole: uve poche ma vere.',
    ],
    hashtags: ['#sangiovese', '#lamolewine', '#chianticlassico', '#biovineyard'],
  },
  {
    id: 6,
    pillar: 'terroir',
    media: { kind: 'sketch', slug: 'biodiversita-in-vigna' },
    caption: [
      'Iris viola. Ginestre. Api.',
      '',
      'La biodiversità non è la fotografia carina. È scelta agronomica. Erbe spontanee tra i filari, insetti utili, il bosco a un passo dalla vigna. La vite ci ringrazia.',
    ],
    hashtags: ['#biodiversity', '#biologico', '#slowwine', '#lamolebio'],
  },
  {
    id: 7,
    pillar: 'prodotto',
    media: { kind: 'photo', src: IG.bottle },
    caption: [
      '1.000 bottiglie. Ci fermeremo qui.',
      '',
      'Non è marketing. È la fotografia della verità: un ettaro recuperato, resa bassa, vinificazione lenta.',
      '',
      'Poche bottiglie, molta anima, nessuna fretta.',
    ],
    hashtags: ['#limitededition', '#lempole', '#rosatoitaliano', '#craftwine'],
  },
  {
    id: 8,
    pillar: 'prodotto',
    media: { kind: 'sketch', slug: 'sangiovese-rosato-contro-corrente' },
    caption: [
      'Un Sangiovese in rosato.',
      '',
      'A Lamole è una scelta contro corrente. In cambio otteniamo un vino teso, freschissimo, con la sapidità degli scisti sotto ai piedi.',
      '',
      'Servire a 10-12°C. Nessuna cerimonia richiesta.',
    ],
    hashtags: ['#rose', '#rosato', '#sangiovesorose', '#pinkinthechianti'],
  },
  {
    id: 9,
    pillar: 'vigneron',
    media: { kind: 'photo', src: IG.basket },
    caption: [
      'Vendemmia a mano. Cassette da 15 kg.',
      '',
      'Le pendenze dei terrazzamenti non lasciano spazio ai trattori. Passiamo noi, con le forbici e la cesta. Le uve arrivano in cantina fredde della notte e intatte.',
    ],
    hashtags: ['#vendemmia2025', '#handpicked', '#slowharvest', '#lempole'],
  },
  {
    id: 10,
    pillar: 'vigneron',
    media: { kind: 'photo', src: IG.vigneron },
    caption: [
      'Raffaello, tra i filari.',
      '',
      'Vent\u2019anni di vendemmie per il mondo — Nuova Zelanda, Frescobaldi, Bibi Graetz, Poggio al Sole — poi la decisione di tornare qui.',
      '',
      '👉 La sua storia: lempole.com/vigneron',
    ],
    hashtags: ['#vigneron', '#winemaker', '#chianti', '#lamolestory'],
  },
  {
    id: 11,
    pillar: 'vigneron',
    media: { kind: 'sketch', slug: 'ritorno-vigneron-lamole' },
    caption: [
      'Il ritorno.',
      '',
      'Dopo il giro del mondo, la scelta più radicale è stata fermarsi. Un ettaro di terrazzamenti, un piccolo oliveto, viti antiche a Lamole. Non un\u2019azienda: una promessa lenta.',
    ],
    hashtags: ['#winereturns', '#comingback', '#tuscany', '#lamole'],
  },
  {
    id: 12,
    pillar: 'terroir',
    media: { kind: 'photo', src: IG.bottlesIris },
    caption: [
      'Fine maggio, tra i filari, l\u2019iris viola.',
      '',
      'Il Giaggiolo toscano fiorisce silenzioso ai bordi delle fasce. Storicamente serviva a delimitare le vigne e a fissare la terra. Oggi ci ricorda che il paesaggio si difende continuando ad abitarlo.',
    ],
    hashtags: ['#irisviola', '#giaggiolo', '#lamolewalks', '#toscanaslowness'],
  },
  {
    id: 13,
    pillar: 'prodotto',
    media: { kind: 'sketch', slug: 'solo-acciaio-perche-no-legno' },
    caption: [
      'Solo acciaio. Nessun legno.',
      '',
      'Per Lempole abbiamo scelto la strada meno indulgente: nessuna barrique, nessun tostato, nessuna maschera. Se il vino è vero, si sente subito.',
      '',
      'La disciplina dell\u2019inox insegna umiltà.',
    ],
    hashtags: ['#steelfermentation', '#nowood', '#pureexpression', '#slowwine'],
  },
  {
    id: 14,
    pillar: 'manifesto',
    media: { kind: 'quote', text: '“Regalo\u2028momenti di\u2028meritata lentezza.”', by: '— Raffaello Tiezzi' },
    caption: [
      'Se una bottiglia di Lempole restituisce cinque minuti di calma vera a chi la apre, allora tutto ha già senso.',
    ],
    hashtags: ['#slowmoment', '#lempole', '#slowfoodphilosophy', '#lamolewine'],
  },
  {
    id: 15,
    pillar: 'vigneron',
    media: { kind: 'photo', src: IG.kidsHarvest },
    caption: [
      'La famiglia, tra le vigne.',
      '',
      'La vendemmia da noi resta un rito familiare. Amici che tornano ogni anno, bambini che portano le cassette, cene sotto il fico. È il pezzo di Lempole che non finisce in bottiglia — ma senza il quale la bottiglia non esisterebbe.',
    ],
    hashtags: ['#familyharvest', '#chiantilife', '#lamole', '#winefamily'],
  },
];
